import angular from 'angular';
import uiRouter from 'angular-ui-router';

import MapsAddressComponent from './mapsAddress.component';

const mapsAddressModule = angular
    .module('tinaba.common.components.mapsAddress.mapsAddress',
        [uiRouter]
    )
    .component('mapsAddress', MapsAddressComponent);

export default mapsAddressModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/mapsAddress/mapsAddress.js
 **/